import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Flex } from 'reflexbox';
import { HealtheraButton } from '../../healtheraComponents';
import * as organisationsActions from '../../redux/organisations';
import { Snackbar } from '@material-ui/core';
import {
  patientsReportProcessReset,
  processPatientsReport,
} from '../../redux/patients-report-processing';

const PatientReportDownload = () => {
  const { organisationID } = useParams();
  const dispatch = useDispatch();

  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);

  const {
    fetching: reportInitFetching,
    error: reportInitError,
    data: reportInitData,
  } = useSelector((state) => state.organisations.patientsReportInit);
  const {
    user: { _id: supportUserId },
  } = useSelector((state) => state.authentication);

  const {
    data: reportProcessingData,
    error: reportProcessingError,
    fetching: reportProcessingFetching,
  } = useSelector((state) => state.patientsReportProcess);

  useEffect(() => {
    if (reportProcessingData?.link) {
      const link = document.createElement('a');
      link.href = reportProcessingData.link;
      link.setAttribute('download', true);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (reportProcessingData?.processing) {
      dispatch(processPatientsReport(organisationID, supportUserId));
    }
  }, [reportProcessingData, dispatch, organisationID, supportUserId]);

  useEffect(() => {
    dispatch(processPatientsReport(organisationID, supportUserId));
  }, [dispatch, organisationID, supportUserId]);

  useEffect(() => {
    if (reportInitData?.processing) {
      dispatch(processPatientsReport(organisationID, supportUserId));
    }
  }, [reportInitData, dispatch, organisationID, supportUserId]);

  useEffect(() => {
    if (reportInitError || reportProcessingError) {
      setErrorSnackbarOpen(true);
    }
  }, [reportInitError, reportProcessingError]);

  useEffect(() => {
    return () => {
      dispatch(organisationsActions.resetPatientsReportAction());
      dispatch(patientsReportProcessReset());
    };
  }, [dispatch]);

  const handlePatientsReportDownload = () => {
    dispatch(organisationsActions.resetPatientsReportAction());
    dispatch(organisationsActions.getPatientsReportInit(organisationID));
  };

  return (
    <div>
      <Snackbar
        open={errorSnackbarOpen}
        onClose={() => setErrorSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={3000}
        message={reportInitError || reportProcessingError}
      />
      <Flex p={2} align="center">
        <HealtheraButton
          disabled={reportInitFetching || reportProcessingFetching}
          onClick={handlePatientsReportDownload}
        >
          {reportProcessingFetching
            ? 'Report generating...'
            : reportInitFetching
            ? 'Check for running reports...'
            : 'Download patients'}
        </HealtheraButton>
      </Flex>
    </div>
  );
};

export default PatientReportDownload;
